import { Component, Input, OnInit, OnDestroy, Inject, Renderer2, HostBinding, Injector } from '@angular/core';
import { DOCUMENT } from '@angular/common';
import { AppService } from 'src/modules/base/shared/services/app.service';
import { Router, ActivatedRoute } from '@angular/router';
import { StorageService } from 'src/modules/base/shared/services/storage.service';
import { CommunicationService } from 'src/modules/base/services/communication.service';
import { BaseService } from 'src/modules/base/shared/services/base.service';
import { AsideBarService } from 'src/modules/base/services/asideBar.service';
import { UtilService } from 'src/modules/base/services/util.service';
import { AuthenticationService } from 'src/modules/base/shared/services/authentication.service';
import { Subscription } from 'rxjs';

@Component({
    selector: 'app-header, cui-header',
    templateUrl: './app-header.component.html',
    standalone: false
})
export class AppHeaderComponent implements OnInit, OnDestroy {

  @Input() fixed: boolean;

  @Input() navbarBrand: any;
  @Input() navbarBrandFull: any;
  @Input() navbarBrandMinimized: any;
  @Input() navbarBrandText: any = { icon: '', text: 'CoreUI' };
  @Input() navbarBrandHref: ''; // deprecated, use navbarBrandRouterLink instead
  @Input() navbarBrandRouterLink: any[] | string = '';

  @Input() sidebarToggler: string | boolean;
  @Input() mobileSidebarToggler: boolean;

  @Input() asideMenuToggler: string | boolean;
  @Input() mobileAsideMenuToggler: boolean;

  private readonly fixedClass = 'header-fixed';

  @HostBinding('class.app-header') _header = true;
  @HostBinding('class.navbar') _navbar = true;

  navbarBrandImg: boolean;

  private readonly breakpoints = ['xl', 'lg', 'md', 'sm', 'xs'];
  sidebarTogglerClass = 'd-none d-md-block';
  sidebarTogglerMobileClass = 'd-lg-none';
  asideTogglerClass = 'd-none d-md-block';
  asideTogglerMobileClass = 'd-lg-none';
  hideMenuIcon: boolean = false;
  headerJson: any = {};
  subs: Subscription = new Subscription();
  constructor(
    @Inject(DOCUMENT) private document: any,
    private renderer: Renderer2,
    public appService: AppService,
    private auth: AuthenticationService,
    public storageService: StorageService,
    private router: Router,
    private route: ActivatedRoute,
    public injector: Injector,
    public baseService: BaseService,
    private communicationService: CommunicationService,
    public asidebarservice: AsideBarService,
    public utilService: UtilService
  ) {
    this.subs.add(this.communicationService.changeEmitted$.subscribe(data => {
      if (data.hideMenuIcon != undefined)
        this.hideMenuIcon = data.hideMenuIcon;
    }));
  }

  ngOnInit(): void {
    if (this.appService.getSessionId()) {
      this.headerJson = this.appService.getAppHeader();
    }
    this.setlogo(this.navbarBrandFull.src,'HeaderLogo');//for normal
    this.setlogo(this.headerJson.fav_icon,'HeaderLogoMobile');//for mobile
    this.headerJson.currentUrl = this.router.url.replace(/^\/|\/$/g, '');
    this.isFixed(this.fixed);
    this.navbarBrandImg = Boolean(this.navbarBrand || this.navbarBrandFull || this.navbarBrandMinimized);
    this.navbarBrandRouterLink = this.navbarBrandRouterLink[0] ? this.navbarBrandRouterLink : this.navbarBrandHref;
    this.sidebarTogglerClass = this.setToggerBreakpointClass(<string>this.sidebarToggler);
    this.sidebarTogglerMobileClass = this.setToggerMobileBreakpointClass(<string>this.sidebarToggler);
    this.asideTogglerClass = this.setToggerBreakpointClass(<string>this.asideMenuToggler);
    this.asideTogglerMobileClass = this.setToggerMobileBreakpointClass(<string>this.asideMenuToggler);
  }

  checktelemedicine() {
    if (this.baseService.getTeleService() != undefined && this.baseService.getTeleService().currentCall.minimized && this.utilService.isMobile()) {
      return "app-telemedicine-minimized"
    } else {
      return ""
    }
  }

  setlogo(url,key) {
    this.storageService.getDataString(key, (val) => { 
      if (val!=undefined && val) {
        this.headerJson[key] = val;
      }
      else {
        this.getBase64ImageFromUrl(url)
          .then((result: any) => {
            this.headerJson[key] = result;
            this.storageService.setData(key, result, () => { });
          })
          .catch(err => console.error(err));
      }
    })
  }

  ngAfterViewInit() {
    console.log("Current Title ", this.baseService._currentTitle);
  }
  ngOnDestroy(): void {
    this.renderer.removeClass(this.document.body, this.fixedClass);
    this.subs.unsubscribe();
  }

  isFixed(fixed: boolean = this.fixed): void {
    if (fixed) {
      this.renderer.addClass(this.document.body, this.fixedClass);
    }
  }

  setToggerBreakpointClass(breakpoint = 'md') {
    let togglerClass = 'd-none d-md-block';
    if (this.breakpoints.includes(breakpoint)) {
      const breakpointIndex = this.breakpoints.indexOf(breakpoint);
      togglerClass = `d-none d-${breakpoint}-block`;
    }
    return togglerClass;
  }

  setToggerMobileBreakpointClass(breakpoint = 'lg') {
    let togglerClass = 'd-lg-none';
    if (this.breakpoints.includes(breakpoint)) {
      togglerClass = `d-${breakpoint}-none`;
    }
    return togglerClass;
  }


  navigateBackUrl() {
    this.asidebarservice.setCloseSideBAr(true);
    // console.log("this.route.snapshot.queryParams.returnUrl",this.route.snapshot.queryParams.returnUrl);
    this.asidebarservice.removeComponent();
    if (this.route.snapshot.queryParams.returnUrl != undefined) {
      if (this.route?.snapshot?.queryParams?.returnUrl.startsWith('/diagnostic/')) {
        const url =sessionStorage.getItem('diagnosticbackUrl')
        if (url) {
          sessionStorage.removeItem('diagnosticbackUrl')
          this.router.navigateByUrl(url)
        }
        else {
          this.router.navigateByUrl(this.route.snapshot.queryParams.returnUrl);
        }
      }
      else {
      this.router.navigateByUrl(this.route.snapshot.queryParams.returnUrl);
      }
    }
    else
    // window.history.back()
    {
      var landingUrl = (this.appService._currentSessionData.dashboardUrlFound != undefined) ? this.appService._currentSessionData.dashboardUrlFound : this.appService._appData.DEFAULT_APPLICATION + '/dashboard';
      this.router.navigateByUrl(landingUrl)
    }
  }

  async getBase64ImageFromUrl(imageUrl) {
    var res = await fetch(imageUrl);
    var blob = await res.blob();

    return new Promise((resolve, reject) => {
      var reader = new FileReader();
      reader.addEventListener("load", function () {
        resolve(reader.result);
      }, false);

      reader.onerror = () => {
        return reject(this);
      };
      reader.readAsDataURL(blob);
    })
  }

  hasHeaderValidation(){
    return true
  }

}
